"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _SearcherFormFilters = _interopRequireDefault(require("../SearcherFormFilters"));
var _DatesCarousel = _interopRequireDefault(require("./DatesCarousel"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Searcher = function Searcher(_ref) {
  var _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
    _ref$fetching = _ref.fetching,
    fetching = _ref$fetching === void 0 ? false : _ref$fetching,
    dates = _ref.dates,
    carouselDate = _ref.carouselDate,
    onChangeCarouselDate = _ref.onChangeCarouselDate,
    onPriceDemand = _ref.onPriceDemand,
    _ref$hideFilters = _ref.hideFilters,
    hideFilters = _ref$hideFilters === void 0 ? false : _ref$hideFilters,
    addServicesFilters = _ref.addServicesFilters,
    activeFilters = _ref.activeFilters,
    onSubmitFilters = _ref.onSubmitFilters,
    startDate = _ref.startDate,
    SearcherStatus = _ref.SearcherStatusComponent,
    currentSearchTypeTab = _ref.currentSearchTypeTab,
    searchType = _ref.searchType,
    isOpenFiltersList = _ref.isOpenFiltersList;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledSearcher, null, !(searchType === 'hotel') && currentSearchTypeTab === 'package' ? /*#__PURE__*/_react["default"].createElement(_DatesCarousel["default"], {
    dates: dates,
    startDate: startDate,
    carouselDate: carouselDate,
    onPriceDemand: onPriceDemand,
    onChangeCarouselDate: onChangeCarouselDate,
    fetching: fetching,
    isMobile: isMobile
  }) : null), /*#__PURE__*/_react["default"].createElement(FiltersRow, {
    isMobile: isMobile
  }, !hideFilters && /*#__PURE__*/_react["default"].createElement(StyledSearcherFormFilters, {
    isMobile: isMobile,
    addServicesFilters: addServicesFilters,
    activeFilters: activeFilters !== null && activeFilters !== void 0 ? activeFilters : {},
    onSubmitFilters: onSubmitFilters,
    isHotelOnly: searchType === 'hotel',
    isOpenFiltersList: isOpenFiltersList
  }), SearcherStatus && /*#__PURE__*/_react["default"].createElement(SearcherStatus, null)));
};
var StyledSearcher = _styledComponents["default"].div.withConfig({
  displayName: "Searcher__StyledSearcher",
  componentId: "sc-ogjtgz-0"
})(["border-radius:", ";box-shadow:0 10px 15px 0 rgba(216,214,204,0.9),0 1px 2px 0 rgba(210,208,197,0.9);"], function (props) {
  return props.theme.shape.borderRadiusBig;
});
var FiltersRow = _styledComponents["default"].div.withConfig({
  displayName: "Searcher__FiltersRow",
  componentId: "sc-ogjtgz-1"
})(["display:flex;align-items:start;flex-wrap:wrap;margin-bottom:10px;margin-top:10px;"]);
var StyledSearcherFormFilters = (0, _styledComponents["default"])(_SearcherFormFilters["default"]).withConfig({
  displayName: "Searcher__StyledSearcherFormFilters",
  componentId: "sc-ogjtgz-2"
})(["display:flex;justify-content:space-between;", ""], function (_ref2) {
  var isMobile = _ref2.isMobile;
  return !isMobile && (0, _styledComponents.css)(["align-items:center;justify-content:center;"]);
});
var _default = exports["default"] = Searcher;